var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconFishingRegular = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.014 5.143a1.38 1.38 0 0 0-.418.064l-2.303.707a6.284 6.284 0 0 0-4.436 6.007v2.365h.286c.79 0 1.428.639 1.428 1.428v5.143c0 .79-.639 1.429-1.428 1.429H6.429c-.79 0-1.429-.64-1.429-1.429v-5.143c0-.789.64-1.428 1.429-1.428h.285V11.92c0-3.26 2.129-6.139 5.243-7.1l2.304-.707a2.56 2.56 0 0 1 3.31 2.443v2.3A.573.573 0 0 1 17 9.43a.573.573 0 0 1-.571-.572v-2.3c0-.782-.633-1.414-1.415-1.414zm1.732 5.203a.56.56 0 0 1 .511 0c.64.318 1.56.968 2.329 1.908C20.357 13.196 21 14.46 21 16c0 1.196-.54 2.89-2.079 4.136l.84 1.26a.574.574 0 0 1-.475.89h-4.572a.567.567 0 0 1-.503-.304c-.1-.19-.09-.41.028-.586l.84-1.26C13.539 18.889 13 17.196 13 16c0-1.54.643-2.804 1.414-3.746.768-.94 1.693-1.586 2.329-1.908h.003zM14.143 16c0 .975.496 2.5 2.032 3.525a.57.57 0 0 1 .157.793l-.55.825h2.436l-.55-.825a.573.573 0 0 1 .157-.793c1.536-1.025 2.032-2.55 2.032-3.525 0-1.204-.5-2.225-1.157-3.025a6.636 6.636 0 0 0-1.7-1.468c-.493.29-1.143.79-1.7 1.468-.657.8-1.157 1.821-1.157 3.025zm-6-.571H6.429a.287.287 0 0 0-.286.285v5.143c0 .157.128.286.286.286h1.714a.287.287 0 0 0 .286-.286v-5.143a.287.287 0 0 0-.286-.285zm9.714-1.143a.857.857 0 1 1 0 1.714.857.857 0 0 1 0-1.714z",
    fill: "#1A202C",
    fillRule: "nonzero",
    stroke: "#1A202C",
    strokeWidth: 0.25
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFishingRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-fishing-regular.f659047b.svg";
export { ForwardRef as ReactComponent };